import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ArrowDownRight, Clock, CreditCard, Send, Wallet, BarChart3 } from 'lucide-react';
const CustomerDashboard = () => {
  // Mock data for demonstration
  const recentTransactions = [{
    id: 1,
    type: 'credit',
    description: 'Wallet Funding',
    amount: 500,
    currency: 'USD',
    date: '2023-06-15',
    status: 'completed'
  }, {
    id: 2,
    type: 'debit',
    description: 'Netflix Subscription',
    amount: 15.99,
    currency: 'USD',
    date: '2023-06-14',
    status: 'completed'
  }, {
    id: 3,
    type: 'debit',
    description: 'Airtime Recharge',
    amount: 10,
    currency: 'USD',
    date: '2023-06-12',
    status: 'completed'
  }];
  const upcomingPayments = [{
    id: 1,
    description: 'Spotify Premium',
    amount: 9.99,
    dueDate: '2023-07-05',
    recurring: true
  }, {
    id: 2,
    description: 'Adobe Creative Cloud',
    amount: 52.99,
    dueDate: '2023-07-10',
    recurring: true
  }, {
    id: 3,
    description: 'Gym Membership',
    amount: 35.0,
    dueDate: '2023-07-15',
    recurring: true
  }];
  const wallets = [{
    id: 1,
    currency: 'USD',
    balance: 2540.5,
    code: 'USD'
  }, {
    id: 2,
    currency: 'GBP',
    balance: 1250.75,
    code: 'GBP'
  }];
  const getCurrencySymbol = (code: string) => {
    const symbols: {
      [key: string]: string;
    } = {
      USD: '$',
      GBP: '£',
      NGN: '₦',
      ZAR: 'R',
      GHS: '₵'
    };
    return symbols[code] || code;
  };
  return <div className="py-6" data-id="element-363">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8" data-id="element-364">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-365">
          Customer Dashboard
        </h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-366">
          Manage your payments, cards, and transactions
        </p>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mt-6" data-id="element-367">
        {/* Quick Actions */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-368">
          <Link to="/dashboard/payment-processor" className="bg-white p-4 rounded-lg shadow flex flex-col items-center justify-center hover:bg-gray-50 transition-colors" data-id="element-369">
            <div className="bg-[#03e8b1]/20 p-2 rounded-full" data-id="element-370">
              <Send className="h-6 w-6 text-[#289f77]" data-id="element-371" />
            </div>
            <span className="mt-2 text-sm font-medium text-gray-900" data-id="element-372">
              Send Money
            </span>
          </Link>
          <Link to="/dashboard/virtual-cards" className="bg-white p-4 rounded-lg shadow flex flex-col items-center justify-center hover:bg-gray-50 transition-colors" data-id="element-373">
            <div className="bg-[#03e8b1]/20 p-2 rounded-full" data-id="element-374">
              <CreditCard className="h-6 w-6 text-[#115800]" data-id="element-375" />
            </div>
            <span className="mt-2 text-sm font-medium text-gray-900" data-id="element-376">
              Virtual Cards
            </span>
          </Link>
          <Link to="/dashboard/wallets" className="bg-white p-4 rounded-lg shadow flex flex-col items-center justify-center hover:bg-gray-50 transition-colors" data-id="element-377">
            <div className="bg-[#03e8b1]/20 p-2 rounded-full" data-id="element-378">
              <Wallet className="h-6 w-6 text-[#289f77]" data-id="element-379" />
            </div>
            <span className="mt-2 text-sm font-medium text-gray-900" data-id="element-380">
              Fund Wallet
            </span>
          </Link>
          <Link to="/dashboard/bill-payments" className="bg-white p-4 rounded-lg shadow flex flex-col items-center justify-center hover:bg-gray-50 transition-colors" data-id="element-381">
            <div className="bg-[#03e8b1]/20 p-2 rounded-full" data-id="element-382">
              <BarChart3 className="h-6 w-6 text-[#115800]" data-id="element-383" />
            </div>
            <span className="mt-2 text-sm font-medium text-gray-900" data-id="element-384">
              Pay Bills
            </span>
          </Link>
        </div>
        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-385">
          {/* Left Column - Wallets */}
          <div className="lg:col-span-1" data-id="element-386">
            <div className="bg-white rounded-lg shadow" data-id="element-387">
              <div className="px-4 py-5 sm:px-6 flex justify-between items-center" data-id="element-388">
                <h2 className="text-lg font-medium text-gray-900" data-id="element-389">
                  My Wallets
                </h2>
                <Link to="/dashboard/wallets" className="text-sm font-medium text-[#289f77] hover:text-[#115800]" data-id="element-390">
                  View all
                </Link>
              </div>
              <div className="border-t border-gray-200 px-4 py-5 sm:p-6" data-id="element-391">
                <div className="space-y-4" data-id="element-392">
                  {wallets.map(wallet => <div key={wallet.id} className="bg-gray-50 p-4 rounded-md" data-id="element-393">
                      <div className="flex justify-between items-center" data-id="element-394">
                        <div className="flex items-center" data-id="element-395">
                          <div className="h-10 w-10 rounded-full bg-[#03e8b1]/20 flex items-center justify-center text-[#115800] font-bold" data-id="element-396">
                            {wallet.currency}
                          </div>
                          <div className="ml-3" data-id="element-397">
                            <p className="text-sm font-medium text-gray-900" data-id="element-398">
                              {wallet.currency} Wallet
                            </p>
                            <p className="text-lg font-semibold text-gray-900" data-id="element-399">
                              {getCurrencySymbol(wallet.code)}{' '}
                              {wallet.balance.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                            </p>
                          </div>
                        </div>
                        <div className="flex flex-col space-y-1" data-id="element-400">
                          <button className="text-xs px-2 py-1 bg-[#03e8b1]/20 text-[#115800] rounded hover:bg-[#03e8b1]/30" data-id="element-401">
                            Fund
                          </button>
                          <button className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded hover:bg-gray-200" data-id="element-402">
                            Transfer
                          </button>
                        </div>
                      </div>
                    </div>)}
                </div>
                <div className="mt-5" data-id="element-403">
                  <button className="w-full flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-404">
                    Add New Wallet
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Middle Column - Transactions */}
          <div className="lg:col-span-2" data-id="element-405">
            <div className="bg-white rounded-lg shadow" data-id="element-406">
              <div className="px-4 py-5 sm:px-6 flex justify-between items-center" data-id="element-407">
                <h2 className="text-lg font-medium text-gray-900" data-id="element-408">
                  Recent Transactions
                </h2>
                <Link to="/dashboard/transactions" className="text-sm font-medium text-[#289f77] hover:text-[#115800]" data-id="element-409">
                  View all
                </Link>
              </div>
              <div className="border-t border-gray-200" data-id="element-410">
                <div className="overflow-hidden" data-id="element-411">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-412">
                    <thead className="bg-gray-50" data-id="element-413">
                      <tr data-id="element-414">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-415">
                          Transaction
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-416">
                          Date
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-417">
                          Amount
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-418">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-419">
                      {recentTransactions.map(transaction => <tr key={transaction.id} data-id="element-420">
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-421">
                            <div className="flex items-center" data-id="element-422">
                              <div className={`flex-shrink-0 h-8 w-8 rounded-full flex items-center justify-center ${transaction.type === 'credit' ? 'bg-green-100' : 'bg-red-100'}`} data-id="element-423">
                                {transaction.type === 'credit' ? <ArrowUpRight className={`h-4 w-4 ${transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'}`} data-id="element-424" /> : <ArrowDownRight className={`h-4 w-4 ${transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'}`} data-id="element-425" />}
                              </div>
                              <div className="ml-4" data-id="element-426">
                                <div className="text-sm font-medium text-gray-900" data-id="element-427">
                                  {transaction.description}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-428">
                            <div className="text-sm text-gray-900" data-id="element-429">
                              {transaction.date}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-430">
                            <div className={`text-sm font-medium ${transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'}`} data-id="element-431">
                              {transaction.type === 'credit' ? '+' : '-'}{' '}
                              {getCurrencySymbol(transaction.currency)}
                              {transaction.amount.toFixed(2)}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-432">
                            <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-433">
                              {transaction.status}
                            </span>
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* Upcoming Payments */}
            <div className="mt-6 bg-white rounded-lg shadow" data-id="element-434">
              <div className="px-4 py-5 sm:px-6 flex justify-between items-center" data-id="element-435">
                <h2 className="text-lg font-medium text-gray-900" data-id="element-436">
                  Upcoming Payments
                </h2>
                <Link to="/dashboard/scheduled-payments" className="text-sm font-medium text-[#289f77] hover:text-[#115800]" data-id="element-437">
                  Manage
                </Link>
              </div>
              <div className="border-t border-gray-200 px-4 py-5 sm:p-6" data-id="element-438">
                <ul className="divide-y divide-gray-200" data-id="element-439">
                  {upcomingPayments.map(payment => <li key={payment.id} className="py-3 flex justify-between items-center" data-id="element-440">
                      <div className="flex items-center" data-id="element-441">
                        <div className="flex-shrink-0" data-id="element-442">
                          <Clock className="h-5 w-5 text-gray-400" data-id="element-443" />
                        </div>
                        <div className="ml-3" data-id="element-444">
                          <p className="text-sm font-medium text-gray-900" data-id="element-445">
                            {payment.description}
                          </p>
                          <p className="text-sm text-gray-500" data-id="element-446">
                            Due: {payment.dueDate}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center" data-id="element-447">
                        <span className="text-sm font-medium text-gray-900" data-id="element-448">
                          ${payment.amount.toFixed(2)}
                        </span>
                        {payment.recurring && <span className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-[#03e8b1]/20 text-[#115800]" data-id="element-449">
                            Recurring
                          </span>}
                      </div>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default CustomerDashboard;